import React from "react";
import { Box, Button, Divider, Typography } from "@material-ui/core";

import QuyChe from "../../../components/GTNS/QuyChe";
import { GTNS2026_LINKS } from "../../../constants/gtns2026.config";

// Trang riêng "Quy chế xét thưởng" Nữ sinh KHCN (điều hướng từ nút Chi tiết ở Giới thiệu).
export default function QuyChePage() {
  return (
    <Box paddingY={3}>
      <Typography
        variant="h4"
        style={{ textAlign: "center", fontFamily: "WorkSans-ExtraBold" }}
      >
        <strong>QUY CHẾ XÉT THƯỞNG</strong>
      </Typography>
      <Typography
        variant="h6"
        style={{ textAlign: "center", fontFamily: "WorkSans-ExtraBold" }}
      >
        <strong>GIẢI THƯỞNG NỮ SINH KHOA HỌC CÔNG NGHỆ VIỆT NAM</strong>
      </Typography>

      {GTNS2026_LINKS.quyetDinhQuyChe ? (
        <Box textAlign="center" marginTop={2}>
          <Button
            color="secondary"
            variant="contained"
            href={GTNS2026_LINKS.quyetDinhQuyChe}
            target="_blank"
            rel="noreferrer"
          >
            Xem toàn bộ Quyết định kèm Quy chế Giải thưởng (PDF)
          </Button>
        </Box>
      ) : null}

      {/* NSKH 2026: nhúng bản PDF quy chế ngay trong trang */}
      {GTNS2026_LINKS.quyChePdfEmbed ? (
        <Box
          marginTop={3}
          style={{
            width: "100%",
            height: "80vh",
            border: "1px solid #e0e0e0",
            borderRadius: 8,
            overflow: "hidden",
          }}
        >
          <iframe
            title="Quy chế Giải thưởng Nữ sinh KHCN"
            src={GTNS2026_LINKS.quyChePdfEmbed}
            style={{ width: "100%", height: "100%", border: 0 }}
            allow="autoplay"
          />
        </Box>
      ) : null}

      <Divider
        style={{
          width: 64,
          height: 4,
          backgroundColor: "#ee6064",
          margin: "24px auto",
        }}
      />

      <QuyChe />
    </Box>
  );
}
